<template>
  <div class="all-box" @contextmenu.stop :style="{ width: allWid + 'px', height: allHei + 'px' }" :class="{ 'mobile-tip': isMobile }">
    <img src="@imgs/stream-tip2x.png" alt="" v-if="!isMobile" />
    <img src="@imgs/stream-mobile-tip2x.png" alt="" @click="tipHide" v-else />
    <div class="pc-btn" @click="tipHide" v-if="!isMobile"></div>
    <div class="mobile-btn" @touchend="tipHide" v-else></div>
    <div class="mask"></div>
  </div>
</template>

<script>
export default {
  name: 'streamTip',
  data() {
    return {
      allHei: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      allWid: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    }
  },
  methods: {
    tipHide() {
      if (this.isMobile) {
        this.$store.commit('book/UPDATE_IS_SHOW_PHONE_STREAM_TIP', false)
        setTimeout(() => {
          this.$store.commit('book/UPDATE_IS_SHOW_TITLE', false)
          this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
        }, 1000)
      } else {
        this.$store.commit('book/UPDATE_IS_SHOW_STREAM_TIP', false)
      }
    }
  },
  created() {
    console.log('height' + this.allHei, 'width' + this.allWid)
  }
}
</script>

<style lang="scss" scoped>
.all-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20000;
  img {
    width: 300px;
    height: 282px;
    position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
    left: -143px;
    top: -242px;
    z-index: 20002;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 20000;
    background-color: rgba(0, 0, 0, 0.84);
  }
  .pc-btn {
    width: 160px;
    height: 40px;
    border-radius: 3px;
    background: transparent;
    position: absolute;
    z-index: 20003;
    top: -149px;
    left: -73px;
    cursor: pointer;
  }
}
// img {
//   width: 300px;
//   height: 282px;
//   position: absolute;
//   bottom: 0;
// }
.mobile-tip {
  img {
    width: 270px;
    height: 270px;
    top: -230px;
    // left: -135px;
    left: -22px;
  }
  .mobile-btn {
    width: 120px;
    height: 36px;
    border-radius: 3px;
    background: transparent;
    position: absolute;
    z-index: 20003;
    top: -133px;
    left: 53px;
  }
}
</style>
